import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './modal.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
    <App />
)








